import React from "react";
import { useParams } from "react-router-dom";

// Components
import { StaticHero } from "../../components/StaticHero";
import { Container, Spinner } from "react-bootstrap";
import { ProductDetail } from "../../components/ProductDetail";
import Footer from "../../components/Footer/Footer";

import { useEffect } from "react";
import { getProductDetails } from "../../actions/Book.action";
import { connect } from "react-redux";

const ProductDetailsPage = ({ getProductDetails, data }) => {
  const { id } = useParams();

  useEffect(() => {
    getProductDetails(id);
  }, [id]);

  //TODO: Get single product detail using id

  const heroConf = {
    title: data && data._id === id ? data.name : "Loading...",
    subtitle: "",
  };
  return (
    <div>
      <StaticHero {...heroConf} contact={false} details={true} />
      <Container className="py-5">
        {data && data._id === id ? (
          <ProductDetail product={data} />
        ) : (
          <div className="py-5">
            <Spinner variant="dark" />
          </div>
        )}
      </Container>
      <Footer />
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.product.selected_product,
});

export default connect(mapStateToProps, { getProductDetails })(
  ProductDetailsPage
);
